exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-412624c5]::-webkit-scrollbar{width:0}.customViewFormInfo .label[data-v-412624c5]{text-align:right;vertical-align:middle;float:left;font-size:14px;color:#606266;padding:0 12px 0 0;-webkit-box-sizing:border-box;box-sizing:border-box}.customViewFormInfo .item[data-v-412624c5]{position:relative;font-size:14px;margin-top:0}.itemClass[data-v-412624c5]{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.itemTextAreaClass[data-v-412624c5]{overflow:hidden;line-height:none;white-space:normal}.title[data-v-412624c5]{border-left:4px solid #b463be;margin-top:10px;margin-bottom:10px;font-family:Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,\\\\5FAE\\8F6F\\96C5\\9ED1,Arial,sans-serif;font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-412624c5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/form/customViewForm.vue
// module id = 914
// module chunks = 0